// ─────────────────────────────────────────────────────────────
//  YOUR PROFILE - Edit this file to personalise the site.
// ─────────────────────────────────────────────────────────────
import profileImg from '../assets/about-baker.jpg'; 
const profile = {
  name: "Avantika Bisht",
  title: "Software Developer & Weekend Baker",
  tagline:
    "I write code at work and bake on weekends. This is where both worlds collide.",
  location: "India 🇮🇳",
  email: "avantikabisht910@gmail.com",
  available: true,
  availableText: "Open to freelance & collabs",
  avatar: profileImg,

  bio: [
    "I'm a software developer who discovered that baking is basically debugging - you follow the recipe, something goes wrong anyway, and you iterate until it's perfect.",
    "Beyond baking & code, I like doing gym, take photos of food before eating it, travel whenever I can, and believe strongly in slow Sunday mornings and iced latte is love of my life.",
    "This site is my creative outlet, portfolio, and recipe box - all in one.",
  ],

  socials: {
    github: "https://github.com/avantika08",
    linkedin: "https://www.linkedin.com/in/avantika-bisht08/",
    instagram: "https://www.instagram.com/the_hill_babe",
  },

  techStack: ["React", "Next.js", "TypeScript", "Node.js", "Python", "Tailwind", "PHP"],

  bakingSpecialties: [
    "Cookies",
    "Brownies",
    "Blondies",
    "Stuffed Cookies",
  ],

  services: [
    {
      icon: "🖥",
      title: "Freelance Dev Work",
      desc: "React, Next.js, Python full-stack web apps, UI/UX implementation.",
    },
    // {
    //   icon: "🧁",
    //   title: "Recipe Collaborations",
    //   desc: "Brand partnerships, sponsored recipes and product features.",
    // },
    // {
    //   icon: "✍️",
    //   title: "Technical Writing",
    //   desc: "Dev tutorials, documentation and content for tech audiences.",
    // },
  ],
};

export default profile;
